import { ValidatedFieldData } from 'out-of-the-vue';
import zxcvbn from 'zxcvbn';

export type ValidatedFieldDataExtended = ValidatedFieldData & {
    ZXCVBNResult: zxcvbn.ZXCVBNResult;
};

export const isPasswordStrong = (ZXCVBNResult: zxcvbn.ZXCVBNResult) => {
    return ZXCVBNResult.score >= 3;
};
